/** paragraph types */
export enum ParagraphType {
  adDividingLine = 'adDividingLine',
  additionalLinks = 'additionalLinks',
  affiliateLink = 'affiliateLink',
  ascendantCalculator = 'ascendantCalculator',
  assetIds = 'assetIds',
  authorBox = 'authorBox',
  buttonGroup = 'buttonGroup',
  carOfferWidget = 'carOfferWidget',
  childTagsTeaserGroup = 'childTagsTeaserGroup',
  contactForm = 'contactForm',
  contentBox = 'contentBox',
  recipeAggregateRating = 'recipeAggregateRating',
  embed = 'embed',
  epgBroadcastRating = 'epgBroadcastRating',
  epgBroadcastReruns = 'epgBroadcastReruns',
  epgWidget = 'epgWidget',
  faq = 'faq',
  fileDownload = 'fileDownload',
  horizontalLine = 'horizontalLine',
  horoscope = 'horoscope',
  hotOrNot = 'hotOrNot',
  iframe = 'iframe',
  image = 'image',
  infoBar = 'infoBar',
  infoTeaser = 'infoTeaser',
  infobox = 'infobox',
  interline = 'interline',
  lexicon = 'lexicon',
  listOfSources = 'listOfSources',
  logoSlider = 'logoSlider',
  moonrun = 'moonrun',
  newsletterTeaser = 'newsletterTeaser',
  pageableTeaserGroup = 'pageableTeaserGroup',
  placeholder = 'placeholder',
  poll = 'poll',
  productAutoComparison = 'productAutoComparison',
  productCard = 'productCard',
  productGroup = 'productGroup',
  quote = 'quote',
  raw = 'raw',
  recipe = 'recipe',
  relatedTags = 'relatedTags',
  search = 'search',
  slider = 'slider',
  socialStrip = 'socialStrip',
  structureTermTree = 'structureTermTree',
  tabbedInfo = 'tabbedInfo',
  table = 'table',
  tableExt = 'tableExt',
  tableOfContents = 'tableOfContents',
  teaser = 'teaser',
  teaserGroup = 'teaserGroup',
  text = 'text',
  tmdbImage = 'tmdbImage',
  video = 'video',
  verticalVideo = 'verticalVideo',
  vodEpgBroadcastSlider = 'vodEpgBroadcastSlider',
  vodEpgTeaserGroup = 'vodEpgTeaserGroup',
  vodRating = 'vodRating',
  vodSeasonWithEpisodes = 'vodSeasonWithEpisodes',
  vodStreamingOptions = 'vodStreamingOptions',
  vodStreamingCard = 'vodStreamingCard',
  vodTeaserForEpgBroadcast = 'vodTeaserForEpgBroadcast',
  vueComponent = 'vueComponent',
  webForm = 'webForm'
}

export enum HeadingType {
  h2 = 'h2',
  h3 = 'h3',
  h4 = 'h4',
  none = '_none'
}

export enum AdDividingLinePosition {
  start = 'start',
  end = 'end'
}

// for search paragraph
export enum SearchFilterType {
  range = 'range',
  option = 'option',
  bubblechooser = 'bubblechooser',
  select = 'select',
  vueSlot = 'vue-slot'
}

export enum SortOrder {
  asc = 'asc',
  desc = 'desc'
}
